import { Pipe, PipeTransform } from '@angular/core';

type DateMode = 'datetime' | 'date' | 'time';

@Pipe({
  name: 'customDate',
  standalone: true,
  pure: true,
})
export class DatePipe implements PipeTransform {
  transform(
    value: string | number | Date | null | undefined,
    mode: DateMode = 'datetime',
    timeZone?: string
  ): string {
    if (value === null || value === undefined || value === '') return '';

    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';

    let options: Intl.DateTimeFormatOptions;
    switch (mode) {
      case 'date':
        options = { year: 'numeric', month: '2-digit', day: '2-digit', timeZone };
        break;
      case 'time':
        options = { hour: '2-digit', minute: '2-digit', timeZone };
        break;
      case 'datetime':
      default:
        options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          timeZone,
        };
        break;
    }

    return new Intl.DateTimeFormat('en-US', options).format(date);
  }
}

